import { render, staticRenderFns } from "./ConsentEditGroup.vue?vue&type=template&id=e7dd5dae&"
import script from "./ConsentEditGroup.vue?vue&type=script&lang=js&"
export * from "./ConsentEditGroup.vue?vue&type=script&lang=js&"
import style0 from "./ConsentEditGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports